import { render, staticRenderFns } from "./PersonalDashboard.vue?vue&type=template&id=66404d12&"
import script from "./PersonalDashboard.vue?vue&type=script&lang=ts&"
export * from "./PersonalDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports